<template>
    <div>
        <el-button type="primary" size="mini" @click.nactive="exportSql">sql</el-button>
    </div>
</template>

<script>
import { hyperfHost } from '@/YsyCollections/host/hyperfHost.js'
export default {
    methods: {
        async exportSql() {
            try {
                const { data } = await this.$axios.post(`${hyperfHost}system/exportStructures`, {},
                    { responseType: 'blob' }
                )
                const blob = new Blob([data], { type: 'application/octet-stream' })
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                const contentDisposition = this.$axios.defaults.headers.common['Content-Disposition']
                let fileName = 'table_structures.sql'
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/)
                    if (match && match[1]) fileName = match[1]
                }
                a.download = fileName
                a.click()
                window.URL.revokeObjectURL(url)
                this.$message.success('文件下载成功')
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/System/OneButton.vue